export const useIndicatorsStore = defineStore('indicatorsStore', {
  state: () => ({
    indicators: [],
    dailySpinCount: [],
    ticketAnimation: false,
    blueFire: null,
    coinIdle: [],
  }),

  getters: {
    tetherValue() {
      const tether = this.indicators.find((item) => item.publicId === 'tether')
      return tether?.value
    },
    gemValue() {
      const gem = this.indicators.find((item) => item.publicId === 'gem')
      return gem?.value
    },
    coinValue() {
      const coin = this.indicators.find((item) => item.publicId === 'coin')
      return coin?.value
    },
    ticketValue() {
      const ticket = this.indicators.find((item) => item.publicId === 'ticket')
      return ticket?.value
    },
    blueFireValue() {
      const blueFire = this.indicators.find(
        (item) => item.publicId === 'blue-fire',
      )
      return blueFire?.value
    },
  },

  actions: {
    async getIndicators() {
      const api = useApi()

      const indicators = await api.getIndicators()
      let newIndicators = indicators['indicators'].filter(
        (item) => item.publicId !== 'daily-spin-count',
      )

      const itemToMove = newIndicators.find(
        (item) => item.publicId === 'tether',
      )

      const newArr = [
        ...newIndicators.filter((item) => item.publicId !== 'tether'),
        itemToMove,
      ]

      this.indicators = newArr

      const spinCount = indicators['indicators'].filter(
        (item) => item.publicId === 'daily-spin-count',
      )
      this.dailySpinCount = spinCount

      const fragment = indicators['indicators'].find(
        (item) => item.publicId === 'blue-fire',
      )
      this.blueFire = fragment.value
    },

    async reduceIndicators(costIndicator, spinCost) {
      const newIndicators = () => {
        console.log(costIndicator, spinCost)
        return this.indicators.map((item) => {
          if (item.publicId === costIndicator) {
            return { ...item, value: item.value - spinCost }
          } else {
            return { ...item }
          }
        })
      }

      this.indicators = newIndicators()
    },

    async decreaseTicket() {
      const newIndicators = () => {
        return this.indicators.map((item) => {
          if (item.publicId === 'ticket') {
            return { ...item, value: item.value - 1 }
          } else {
            return { ...item }
          }
        })
      }

      this.indicators = newIndicators()
      // this.ticketAnimation = true
    },
  },
})
